var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.975,
    height: 20,
    viewBox: "0 0 20.975 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30548",
    "data-name": "Path 30548",
    d: "M20.469,19.3H18.152V4.567A3.692,3.692,0,0,0,14.46.875H7.181a3.7,3.7,0,0,0-3.7,3.692V19.3H1.12a.787.787,0,1,0,0,1.573h19.4a.787.787,0,1,0,0-1.573Zm-8.065,0H9.132V14.75a.671.671,0,0,1,.189-.472.661.661,0,0,1,.472-.189h1.94a.661.661,0,0,1,.671.661Zm1.269-9.093H7.853a.787.787,0,1,1,0-1.573h5.821a.787.787,0,1,1,0,1.573Zm0-3.88H7.853a.787.787,0,1,1,0-1.573h5.821a.787.787,0,0,1,0,1.573Z",
    transform: "translate(-0.333 -0.875)",
    fill: "#f2824c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyHover);
export default __webpack_public_path__ + "static/media/CompanyHover.f7bb648fa30dc0c11a957dadc67cfeb7.svg";
export { ForwardRef as ReactComponent };